import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined'
import styles from './IncompleteProfileDialog.module.scss'

interface IProps {
  open: boolean
  handleClose: () => void
  title?: string
  message?: string
  profilePath?: string
}

export const IncompleteProfileDialog = (props: IProps) => {
  const {
    open,
    handleClose,
    title,
    message,
    profilePath = '/account/settings',
  } = props

  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleGoToProfile = () => {
    handleClose()
    navigate(profilePath)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      classes={{
        paper: styles.dialogPaper,
      }}
    >
      <DialogTitle className={styles.dialogTitle}>
        <Box className={styles.iconWrapper}>
          <WarningAmberRoundedIcon className={styles.warningIcon} />
        </Box>
        <Typography variant="h6" className={styles.titleText}>
          {title || t('Action Not Available')}
        </Typography>
      </DialogTitle>

      <DialogContent className={styles.dialogContent}>
        <Box className={styles.messageBox}>
          <AccountBalanceWalletOutlinedIcon className={styles.billingIcon} />
          <Typography className={styles.messageText}>
            {message ||
              t(
                'To perform this action, please complete your profile by filling in all required fields in the Billing Information section.'
              )}
          </Typography>
        </Box>

        <Box className={styles.infoBox}>
          <Typography className={styles.infoTitle}>
            {t('Required Information')}:
          </Typography>
          <ul className={styles.infoList}>
            <li>{t('Address')}</li>
            <li>{t('City')}</li>
            <li>{t('Zip/Postal Code')}</li>
            <li>{t('Country')}</li>
          </ul>
        </Box>
      </DialogContent>

      <DialogActions className={styles.dialogActions}>
        <Button onClick={handleClose} className={styles.cancelButton}>
          {t('Close')}
        </Button>
        <Button onClick={handleGoToProfile} className={styles.primaryButton}>
          {t('Go to Billing Information')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}